'use client';

import { useState } from 'react';
import { Bell } from 'lucide-react';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from './ui/sheet';
import type { WikiUser } from '../lib/wiki-auth';
import { wikiProfilePath } from '../lib/wiki-profile-path';
import './message-center.css';

export default function MessageCenter({
  open,
  onOpenChange,
  user,
  gameDomain,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: WikiUser | null;
  gameDomain?: string;
}) {
  const [tab, setTab] = useState<'replies' | 'likes'>('replies');
  return (
    <Sheet open={open && !!user} onOpenChange={onOpenChange}>
      <SheetContent className="shared-message-center">
        <div className="message-center-user">
          <strong>{user?.name}</strong>
          <a href={wikiProfilePath(gameDomain)}>进入个人中心 →</a>
        </div>
        <SheetTitle>消息中心</SheetTitle>
        <SheetDescription>查看回复与点赞通知。</SheetDescription>
        <nav className="message-center-shortcuts" aria-label="个人内容">
          <a href={wikiProfilePath(gameDomain, 'history')}>浏览记录</a>
          <a href={wikiProfilePath(gameDomain, 'favorites')}>我的收藏</a>
        </nav>
        <div className="message-center-tabs">
          <button
            aria-pressed={tab === 'replies'}
            onClick={() => setTab('replies')}
          >
            回复我的
          </button>
          <button
            aria-pressed={tab === 'likes'}
            onClick={() => setTab('likes')}
          >
            点赞我的
          </button>
        </div>
        <div className="message-center-empty">
          <Bell size={30} />
          <strong>
            {tab === 'replies' ? '回复通知暂不可用' : '点赞通知暂不可用'}
          </strong>
          <p>消息通知接口尚未接入，当前无法读取消息和未读数量。</p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
